import DataType from '@opsbase/lib-datatype/DataType';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import Vertical from '@opsbase/web-layout/Vertical';
import React, { useMemo } from 'react';
import OpDefinitionCreateConfigurationSetting from './OpDefinitionCreateConfigurationSetting';
export function OpDefinitionCreateConfigurations(props) {
    const { onRemove, value, onChange, type } = props;
    const handleChangePlace = useCallforward(item => permitted => {
        const places = permitted.map(({ id, title }) => ({ id, title }));
        const definitions = value.map(d => d === item
            ? {
                ...d,
                places,
            }
            : d);
        onChange(definitions);
    }, [value, onChange]);
    const handleChangeOpType = useCallforward(item => opType => {
        const definitions = value.map(d => d === item
            ? {
                ...d,
                type: opType,
            }
            : d);
        onChange(definitions);
    }, [value, onChange]);
    const handleChangeOpTitle = useCallforward(item => e => {
        const title = e.target.value;
        const definitions = value.map(d => (d === item ? { ...d, title } : d));
        onChange(definitions);
    }, [value, onChange]);
    const handleSelectAllTeamsPositions = useCallforward(item => selected => {
        const definitions = value.map(d => d === item
            ? {
                ...d,
                allPTsPermitted: selected,
                teams: selected ? [] : d.teams,
                positions: selected ? [] : d.positions,
            }
            : d);
        onChange(definitions);
    }, [value, onChange]);
    const handleChangeTeamsPositions = useCallforward(item => permitted => {
        var _a, _b;
        const teams = (_a = permitted
            .filter(p => {
            var _a, _b;
            return (p.type || ((_a = p.type) === null || _a === void 0 ? void 0 : _a.toLowerCase())) === DataType.TEAM ||
                ((_b = p.__typename) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === DataType.TEAM;
        })) === null || _a === void 0 ? void 0 : _a.map(({ id, title, type: newType }) => ({ id, title, type: newType }));
        const positions = (_b = permitted
            .filter(p => {
            var _a, _b;
            return (p.type || ((_a = p.type) === null || _a === void 0 ? void 0 : _a.toLowerCase())) === DataType.POSITION ||
                ((_b = p.__typename) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === DataType.POSITION;
        })) === null || _b === void 0 ? void 0 : _b.map(({ id, title, type: newType }) => ({ id, title, type: newType }));
        const definitions = value.map(d => d === item
            ? {
                ...d,
                teams,
                positions,
                allPTsPermitted: !(teams.length || positions.length),
            }
            : d);
        onChange(definitions);
    }, [value, onChange]);
    const handleChangeEnabled = useCallforward(item => enabled => {
        onChange(value.map(d => (d === item ? { ...d, enabled } : d)));
    }, [value, onChange]);
    const handleChangeScoreEnabled = useCallforward(item => isScoreEnabled => {
        onChange(value.map(d => (d === item ? { ...d, isScoreEnabled } : d)));
    }, [value, onChange]);
    const handleRemoveOpDefinition = useCallforward(v => () => onRemove(v), [onRemove]);
    return useMemo(() => (React.createElement(Vertical, { gutter: true }, value.map(item => (React.createElement(OpDefinitionCreateConfigurationSetting, { disableRemove: value.length === 1, item: item, type: type, onChangeTitle: handleChangeOpTitle(item), onChangePlace: handleChangePlace(item), onChangeEnabled: handleChangeEnabled(item), onChangeTeamsPositions: handleChangeTeamsPositions(item), onChangeScoreEnabled: handleChangeScoreEnabled(item), onSelectAllTeamsPositions: handleSelectAllTeamsPositions(item), onChangeOpType: handleChangeOpType(item), onRemove: handleRemoveOpDefinition(item) }))))), [
        handleChangeEnabled,
        handleChangeOpTitle,
        handleChangeOpType,
        handleChangePlace,
        handleChangeScoreEnabled,
        handleChangeTeamsPositions,
        handleRemoveOpDefinition,
        handleSelectAllTeamsPositions,
        type,
        value,
    ]);
}
export default OpDefinitionCreateConfigurations;
